import React from "react";
import { useState } from "react";
import { useSelector, useDispatch } from "types/store";
import styles from "./style.module.css";

import { Button, ButtonGroup } from "aible";

import { isEnabled } from "utils/featureFlags";

import { LineInput } from "components/Inputs/LineInput";

import GoogleDocsExport from "components/ChatGPT/GoogleDocsExport";

import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import { hasOutputContent } from "types/chat_conversation";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

const ChatExportModal = ({} = {}) => {
  const dispatch = useDispatch();

  const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
  const next = useSelector((state) => nextReducer.getNext(state, nextId));

  const [chatName, updateChatName] = useState(next?.reportLabel ?? "New Export Chat");
  const [exportType, updateExportType] = useState("PDF");
  const [exportAnswersSetting, updateExportSettingAnswers] = useState("BOTH");
  const [exportAllAnalyticSteps, updateExportAllAnalyticsSteps] = useState(true);
  const [googleClientId, updateGoogleClientId] = useState(localStorage?.getItem("aible_googleClientId") ?? undefined);
  const updateAndSaveGoogleClientId = (gci) => {
    localStorage.setItem("aible_googleClientId", gci);
    updateGoogleClientId(gci);
  };

  const updateIsShowChatExportModal = (isShowChatExportModal) =>
    dispatch(chatGPTReducer.updateIsShowChatExportModal(isShowChatExportModal));

  const isShowChatExportModal = useSelector((state) => chatGPTReducer.getIsShowChatExportModal(state));

  const exportChatToWord = (exportArray, fileName) => dispatch(chatGPTReducer.exportChatToWord(exportArray, fileName));
  const exportChatToText = (exportArray, fileName) => dispatch(chatGPTReducer.exportChatToText(exportArray, fileName));
  const exportChatToPDF = (exportArray, fileName) => dispatch(chatGPTReducer.exportChatToPDF(exportArray, fileName));

  const conversationArray = useSelector((state) => chatGPTReducer.getConversationArray(state));
  const [exportConversationArray, updateExportConversationArray] = useState(conversationArray ?? []);

  const isAllMessagesExported = exportConversationArray.reduce((a, b) => a && b?.isIgnoreExport !== true, true);

  const hasAnalyticsMessages = conversationArray.reduce((a, b) => a || b?.blueprintId === "CHATAIBLE_ANALYTICS", false);

  const updateExportMessage = (message, index) => {
    const retConvoArray = [...exportConversationArray];
    retConvoArray[index] = message;
    updateExportConversationArray(retConvoArray);
  };

  return (
    <Dialog open={isShowChatExportModal} onOpenChange={() => updateIsShowChatExportModal(false)}>
      <DialogContent size="xl">
        <DialogHeader>
          <DialogTitle>Export Chat</DialogTitle>
        </DialogHeader>

        <div className={styles.modalBody}>
          <div className={styles.exportConversation}>
            <div style={{ fontWeight: "bold" }}>{"Select Messages to Export"}</div>
            <div className={styles.exportConversationTable}>
              <div className={styles.exportConversationMessage}>
                <div className={styles.exportTableCheckbox}>
                  <input
                    type="checkbox"
                    checked={isAllMessagesExported}
                    onClick={() => {
                      updateExportConversationArray([
                        ...exportConversationArray.map((cMessage) => ({
                          ...cMessage,
                          isIgnoreExport: isAllMessagesExported
                        }))
                      ]);
                    }}
                  />
                </div>
                <div className={styles.exportTableType}>{"All/None"}</div>
                <div className={styles.exportTableMessage}></div>
              </div>
              {exportConversationArray.map((cMessage, i) => (
                <div
                  key={i}
                  className={
                    styles.exportConversationMessage +
                    " " +
                    (exportAnswersSetting === "ANSWERS" && cMessage?.user === "User"
                      ? styles.exportConversationMessageDisabled
                      : "")
                  }
                  onClick={() =>
                    updateExportMessage(
                      {
                        ...cMessage,
                        isIgnoreExport: !cMessage?.isIgnoreExport
                      },
                      i
                    )
                  }
                >
                  <div className={styles.exportTableCheckbox}>
                    <input type="checkbox" checked={cMessage?.isIgnoreExport !== true} />
                  </div>
                  <div className={styles.exportTableType}>{cMessage?.user === "User" ? "User" : "LLM"}</div>
                  <div className={styles.exportTableMessage} title={cMessage?.userText ?? cMessage?.text}>
                    {cMessage?.userText ?? cMessage?.text}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className={styles.exportType}>
            <div style={{ fontWeight: "bold" }}>{"Export Steps Setting"}</div>
            <ButtonGroup>
              <Button
                onClick={() => {
                  updateExportSettingAnswers("BOTH");
                  updateExportConversationArray([
                    ...exportConversationArray.map((cMessage) => ({
                      ...cMessage,
                      isIgnoreExport: cMessage?.user === "User" ? false : cMessage?.isIgnoreExport
                    }))
                  ]);
                }}
                active={exportAnswersSetting === "BOTH"}
              >
                {"Both (User and Answers)"}
              </Button>
              <Button
                onClick={() => {
                  updateExportSettingAnswers("ANSWERS");
                  updateExportConversationArray([
                    ...exportConversationArray.map((cMessage) => ({
                      ...cMessage,
                      isIgnoreExport: cMessage?.user === "User" ? true : cMessage?.isIgnoreExport
                    }))
                  ]);
                }}
                active={exportAnswersSetting === "ANSWERS"}
              >
                {"Only Answers"}
              </Button>
            </ButtonGroup>
          </div>
          {hasAnalyticsMessages && (
            <div className={styles.exportType}>
              <div style={{ fontWeight: "bold" }}>{"Export Steps Setting"}</div>
              <ButtonGroup>
                <Button
                  onClick={() => {
                    updateExportAllAnalyticsSteps(true);
                    updateExportConversationArray([
                      ...exportConversationArray.map((cMessage) => ({
                        ...cMessage,
                        isIgnoreExport:
                          cMessage?.blueprintId === "CHATAIBLE_ANALYTICS" ? false : cMessage?.isIgnoreExport
                      }))
                    ]);
                  }}
                  active={exportAllAnalyticSteps === true}
                >
                  {"Export All Analytics Steps"}
                </Button>
                <Button
                  onClick={() => {
                    updateExportAllAnalyticsSteps(false);
                    updateExportConversationArray([
                      ...exportConversationArray.map((cMessage) => ({
                        ...cMessage,
                        isIgnoreExport:
                          cMessage?.blueprintId === "CHATAIBLE_ANALYTICS" &&
                          !hasOutputContent(cMessage) &&
                          cMessage?.ids !== undefined
                            ? false
                            : cMessage?.blueprintId === "CHATAIBLE_ANALYTICS"
                              ? true
                              : cMessage?.isIgnoreExport
                      }))
                    ]);
                  }}
                  active={exportAllAnalyticSteps !== true}
                >
                  {"Hide Extra Analytics Steps"}
                </Button>
              </ButtonGroup>
            </div>
          )}
          <div className={styles.exportType}>
            <div style={{ fontWeight: "bold" }}>{"Export Type"}</div>
            <ButtonGroup>
              <Button onClick={() => updateExportType("PDF")} active={exportType === "PDF"}>
                {"PDF"}
              </Button>
              <Button onClick={() => updateExportType("WORD")} active={exportType === "WORD"}>
                {"Word Document"}
              </Button>
              <Button onClick={() => updateExportType("TEXT")} active={exportType === "TEXT"}>
                {"Text Document"}
              </Button>
              {isEnabled("allow-chat-export-google") && (
                <Button onClick={() => updateExportType("GOOGLE")} active={exportType === "GOOGLE"}>
                  {"Google Docs"}
                </Button>
              )}
            </ButtonGroup>
          </div>
        </div>
        <DialogFooter>
          <Button type="secondary" onClick={() => updateIsShowChatExportModal(false)} style={{ marginRight: "auto" }}>
            {"Close"}
          </Button>
          <div className={styles.modalFileName}>{"File Name"}</div>
          <LineInput style={{ marginRight: "5px" }} value={chatName} onChange={(val) => updateChatName(val)} />
          {exportType === "GOOGLE" && (
            <div className={styles.googleCreds}>
              <div className={styles.modalFileName}>{"Google Client ID"}</div>
              <input
                value={googleClientId}
                onChange={(event) => updateAndSaveGoogleClientId(event.currentTarget.value)}
              />
            </div>
          )}
          {exportType === "GOOGLE" && googleClientId !== undefined && googleClientId !== "" ? (
            <GoogleDocsExport
              exportArray={exportConversationArray}
              fileName={chatName}
              googleClientId={googleClientId}
            />
          ) : (
            <Button
              type="primary"
              onClick={() => {
                exportType === "WORD"
                  ? exportChatToWord(exportConversationArray, chatName)
                  : exportType === "TEXT"
                    ? exportChatToText(exportConversationArray, chatName)
                    : exportType === "PDF"
                      ? exportChatToPDF(exportConversationArray, chatName)
                      : exportChatToText(exportConversationArray, chatName);
              }}
            >
              {"Export"}
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ChatExportModal;
